import pick from 'lodash/pick';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const getInputContainerClassName = props => (
  classNames(props.wrapperClassName, {
    'has-error': props.showAlertTriangle
  })
);

const InputComponent = props => (
  <div className={getInputContainerClassName(props)}>
    <label className={props.labelClassName} htmlFor={props.id}>
      {props.label}

      {props.showAlertTriangle &&
        <i
          className="icon icon-alert-triangle"
          onMouseEnter={props.onAlertTriangleMouseEnter}
          onMouseLeave={props.onAlertTriangleMouseLeave}
        />
      }
    </label>

    <input
      id={props.id || props.name}
      pattern="\d+"

      {...pick(props, [
        'type',
        'step',
        'value',

        'min',
        'max',

        'onChange',
        'disabled'
      ])}

      className={props.inputClassName}
    />

    {props.showAlertTriangle && props.isPopupVisible &&
      <span className="main-tooltip main-input__tooltip">
        {props.error}
      </span>
    }
  </div>
);
InputComponent.propTypes = {
  // values
  id: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string,

  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,

  isPopupVisible: PropTypes.bool.isRequired,
  showAlertTriangle: PropTypes.bool.isRequired,

  inputClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,

  // callbacks
  onAlertTriangleMouseEnter: PropTypes.func.isRequired,
  onAlertTriangleMouseLeave: PropTypes.func.isRequired
};

InputComponent.defaultProps = {
  labelClassName: 'main-input__label',
  inputClassName: 'main-input__input',

  wrapperClassName: 'flex-grow flex-basis mb-15 relative'
};

export default InputComponent;
